import { Controller } from "@hotwired/stimulus"
import { h, render } from "preact"
import { IvrFlowDesigner } from "../components/call_center/components/IvrFlowDesigner"

// IVR Flow Designer Stimulus Controller
export default class extends Controller {
  static values = {
    flowId: String,
    configuration: Object,
    saveUrl: String
  }

  connect() {
    console.log("IVR Flow Designer controller connected")
    this.mountDesigner()
  }

  disconnect() {
    this.unmountDesigner()
  }

  mountDesigner() {
    const container = this.element.querySelector("#ivr-flow-designer-mount")
    if (!container) {
      console.error("Designer mount container not found")
      return
    }

    // Render the Preact component
    render(
      h(IvrFlowDesigner, {
        flowId: this.flowIdValue,
        initialConfiguration: this.configurationValue,
        saveUrl: this.saveUrlValue
      }),
      container
    )
  }

  unmountDesigner() {
    const container = this.element.querySelector("#ivr-flow-designer-mount")
    if (container) {
      render(null, container)
    }
  }

  showError(message) {
    const container = this.element.querySelector("#ivr-flow-designer-mount")
    if (container) {
      container.innerHTML = `
        <div class="d-flex justify-content-center align-items-center h-100">
          <div class="alert alert-danger">
            <i class="bi bi-exclamation-triangle"></i> ${message}
          </div>
        </div>
      `
    }
  }
}
